import { FanCheckInInfo } from "../../models/fanCheckInInfo";
import { useTranslation } from "react-i18next";
import { FanInfoTable } from "../fanInfo/fanInfoTable";
import { PenaltyActions } from "../fanInfo/penaltyActions";
import { useEffect, useRef, useState } from "react";
import { PenaltyStatus } from "../../models/penaltyStatus";
import { CheckInButton } from "../fanInfo/checkInButton";
import { Id, toast } from "react-toastify";
import { Loading } from "../common/Loading";
import { WinnerIdInfo } from "../../models/winnerIdInfo";

export function QueryResult({
  artistId,
  eventId,
  rewardId,
  fanInfo,
  onChangeStatus,
}: {
  artistId: number;
  eventId: number;
  rewardId: number;
  fanInfo: FanCheckInInfo | null;
  onChangeStatus: () => void;
}) {
  const { t } = useTranslation();
  const [penaltyStatus, setPenaltyStatus] = useState<PenaltyStatus | undefined>(
    fanInfo?.penaltyStatus(),
  );
  const toastId = useRef<Id>();

  useEffect(() => {
    setPenaltyStatus(fanInfo?.penaltyStatus());
  }, [fanInfo]);

  return (
    <>
      <div className={"overflow-y-auto"}>
        <p className={"m-2 p-2"}>{t("checkinlist_result_subtitle")}</p>
        {fanInfo ? (
          <div className={"m-2 p-2"}>
            <FanInfoTable fanInfo={fanInfo} />
            <PenaltyActions
              penaltyStatus={penaltyStatus}
              onChangeStatus={async (status) => {
                setPenaltyStatus(status);
                onChangeStatus();
              }}
              artistId={artistId}
              eventId={eventId}
              rewardId={rewardId}
              ticketCode={fanInfo.ticketCode}
              checkInStatus={fanInfo.ticketStatus}
              fanIds={new WinnerIdInfo(fanInfo.fan.id, fanInfo.winnerId)}
            />
          </div>
        ) : (
          <div className={"w-full h-full text-center"}>
            {t("checkinlist_noresult")}
          </div>
        )}
      </div>
      {fanInfo && (
        <CheckInButton
          onChange={({ isChecked, isLoading }) => {
            if (isLoading) {
              toastId.current = toast.loading(<Loading />, {
                type: "info",
              });
            } else {
              if (toastId.current) {
                toast.update(toastId.current, {
                  render: t("checkinlist_flashmsg_cancel"),
                  isLoading: false,
                  autoClose: 2000,
                  type: "success",
                  onClose: () => {
                    toastId.current = undefined;
                    window.location.reload();
                  },
                });
              }
            }
          }}
          artistId={artistId}
          eventId={eventId}
          rewardId={rewardId}
          winnerId={fanInfo.winnerId}
          ticketCode={fanInfo.ticketCode}
          status={fanInfo?.ticketStatus}
          isTardy={fanInfo?.isTardy()}
        />
      )}
    </>
  );
}
